/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface TasksKitViewSelectSignature {
  Args: {
    onViewChange: (view: 'resolved' | 'open') => void;
    resolvedCount?: number;
    selectedView: 'resolved' | 'open';
    unresolvedCount?: number;
    disabled?: boolean;
  };
  Element: HTMLElement;
}

const TasksKitViewSelectComponent = templateOnlyComponent<TasksKitViewSelectSignature>();

export default TasksKitViewSelectComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::ViewSelect': typeof TasksKitViewSelectComponent;
    'tasks-kit/view-select': typeof TasksKitViewSelectComponent;
  }
}
